import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Header = styled.div`
    background: ${colors.bluelightest};
    color: ${colors.bluedarkest};
    font-size: 1.9rem;
    padding: 2.5rem 4rem;
    margin: 0;
    text-transform: capitalize;
`

const ListWrapper = styled.ul`
    border-top: 1px solid ${colors.bluelighter2};
    padding: 2.5rem 4rem;
    margin: 0;
`

const DashboardEntry = styled.li`
    border: 1px solid ${colors.grey};
    border-radius: 5px;
    display: block;
    margin-bottom: 5px;
    max-width: 500px;
`

const DashboardLink = styled(Link)`
    color: ${colors.bluedarkest};
    display: flex;
    font-size: 18px;
    padding: 1rem 1rem 1rem 1.2rem;
    text-decoration: none;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`

const DashboardIcon = styled(FontAwesomeIcon)`
    color: ${colors.bluedark};
`

const DashboardLeftIcon = styled(DashboardIcon)`
    margin-right: 0.8rem;
`

export {
    DashboardEntry,
    DashboardIcon,
    DashboardLeftIcon,
    DashboardLink,
    Header,
    ListWrapper,
}
